// extracted by mini-css-extract-plugin
module.exports = {"detailContainer":"index_detailContainer__OFvCY","editContainer":"index_editContainer__1BJ-c","wrapperUploadImage":"index_wrapperUploadImage__2XqBx"};